if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
          copyButton: this.querySelector('.share-button__copy'),
          whatsappButton: this.querySelector('.share-button__whatsapp')
        };

        this.urlToShare = this.elements.urlInput
          ? this.elements.urlInput.value
          : document.location.href;

        // Fallback: Manual Copy + WhatsApp
        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
        this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
        this.elements.closeButton.addEventListener('click', this.close.bind(this));
        this.elements.whatsappButton?.addEventListener('click', this.shareViaWhatsApp.bind(this));
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.urlToShare).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        });
      }

      shareViaWhatsApp() {
        const encodedText = encodeURIComponent(this.urlToShare);
        const whatsappURL = `https://wa.me/?text=${encodedText}`;
        window.open(whatsappURL, '_blank');
      }

      updateUrl(url) {
        this.urlToShare = url;
        // urlInput can be omitted in some templates (we fallback to document.location.href)
        if (this.elements.urlInput) this.elements.urlInput.value = url;
      }
    }
  );
}
